import { TFunction } from "react-i18next";
import { ListConfigFilter } from "go-list/core/components/Filter/services/types";
import { getReportFilter } from "go-report/reports/services/report-service";
import { apiReport } from "../../services/Api/Report/apiReport";

export const capitalizeFirstLetter = (text: string) => {
	return `${text.charAt(0).toUpperCase()}${text.slice(1)}`;
};

export const getCommonBarcodeGroup = (t: TFunction) => ({
	id: "barcode",
	name: t("common.word.barcode"),
});

export const getCommonBarcodeFilter = (t: TFunction, filtersParams?: string) => ({
	id: "barcode",
	name: t("common.word.barcode"),
	type: "label_search_select",
	source: {
		request: (queryString?: string, params?: Record<string, any>) =>
			getReportFilter(
				apiReport.getReportFilter,
				"BARCODE",
				queryString,
				filtersParams,
				"order_item",
				undefined,
				params
			),
	},
});

export const getCommonPaymentStatusGroup = (t: TFunction, isPaymentMethodReport = false) => ({
	id: `${isPaymentMethodReport ? "" : "PAYMENT_"}STATUS`,
	name: t("common.word.payment_status"),
});

export const getCommonPaymentStatusGroupInfo = (t: TFunction, isPaymentMethodReport = false) => ({
	[`${isPaymentMethodReport ? "" : "PAYMENT_"}STATUS`]: (groupByValue: Record<string, any>) => {
		if (groupByValue.name === "OPEN") return t("enums.common.status.UNPAID");
		return t("enums.common.status.PAID");
	},
});

export const getCommonPaymentStatusFilter = (t: TFunction, isPaymentMethodReport = false): ListConfigFilter => ({
	id: `${isPaymentMethodReport ? "" : "PAYMENT_"}STATUS`,
	name: t("common.word.payment_status"),
	type: "list",
	listOptions: {
		OPEN: t("enums.common.status.UNPAID"),
		PAID: t("enums.common.status.PAID"),
	},
});
